import React from "react";

function Footer() {
  return (
    <div>
      <h3 className=" text-white">
        Developed by <a href="https://github.com/urlunaticguy">Souvik Das</a>
      </h3>
    </div>
  );
}

export default Footer;
